// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-bZrgFnFp","foot_link":"foot_link-1fFjJ7SS","list":"list-ZunbRAyl","link":"link-1-2Xb1GE","copyright":"copyright-3ij-N5HI"};